(function () {
    'use strict';

    angular
        .module('commissionsPayment')
        .config(CommissionsPaymentRoute);

    /* @ngInject */
    function CommissionsPaymentRoute($stateProvider) {
        $stateProvider
            .state ('root.commissionsPayment', {
                url: '/commissions',
                abstract: true
            })
            .state ('root.commissionsPayment.list', {
                url: '/list',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/commissions-payment/list/list.html',
                        controller: 'CommissionsPaymentListController',
                        controllerAs: 'commissionsPayment'
                    }
                }
            });
    }
})();